/**
 * Media Showcase — Slider Web Component
 *
 * Handles arrow navigation (disabled state at ends), pagination dots
 * (active state follows scroll position, click-to-scroll), and keeps
 * itself in sync on resize. Modeled after mto-list-slider's arrow logic.
 */
if (!customElements.get('media-showcase-slider')) {
  class MediaShowcaseSlider extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
      this._onPrev = this._onPrev.bind(this);
      this._onNext = this._onNext.bind(this);
      this._onResize = this._onResize.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('.ms-track');
      if (!this.track) return;

      this.prevBtn = this.querySelector('.ms-nav--prev');
      this.nextBtn = this.querySelector('.ms-nav--next');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));

      if (this.prevBtn) {
        this.prevBtn.hidden = false;
        this.prevBtn.addEventListener('click', this._onPrev);
      }
      if (this.nextBtn) {
        this.nextBtn.hidden = false;
        this.nextBtn.addEventListener('click', this._onNext);
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this._scrollToIndex(parseInt(dot.dataset.index, 10)));
      });

      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });

      this._update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }

    _onResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this._update(), 100);
    }

    _onScroll() {
      cancelAnimationFrame(this._scrollRAF);
      this._scrollRAF = requestAnimationFrame(() => this._update());
    }

    _tileStep() {
      var tile = this.track.querySelector('.ms-tile');
      if (!tile) return 0;
      return tile.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
    }

    _onPrev() {
      this.track.scrollBy({ left: -this._tileStep(), behavior: 'smooth' });
    }

    _onNext() {
      this.track.scrollBy({ left: this._tileStep(), behavior: 'smooth' });
    }

    _scrollToIndex(index) {
      var step = this._tileStep();
      if (!step) return;
      this.track.scrollTo({ left: step * index, behavior: 'smooth' });
    }

    _update() {
      var maxScroll = this.track.scrollWidth - this.track.clientWidth;

      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
      if (this.nextBtn) this.nextBtn.disabled = maxScroll <= 0 || this.track.scrollLeft >= maxScroll - 2;

      if (this.dots.length) {
        var step = this._tileStep();
        var activeIndex = step ? Math.round(this.track.scrollLeft / step) : 0;
        this.dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === activeIndex);
        });
      }
    }
  }

  customElements.define('media-showcase-slider', MediaShowcaseSlider);
}
